"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var Portal = (function (_super) {
    __extends(Portal, _super);
    function Portal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createNode = function () {
            _this.defaultNode = document.createElement("div");
            _this.defaultNode.setAttribute("tabindex", "-1");
            _this.defaultNode.id = "portal--container";
            document.body.appendChild(_this.defaultNode);
        };
        return _this;
    }
    Portal.prototype.render = function () {
        var _a = this.props, children = _a.children, node = _a.node;
        this.defaultNode = document.querySelector("#portal--container");
        if (!node && !this.defaultNode) {
            this.createNode();
        }
        return react_dom_1.default.createPortal(children, node || this.defaultNode);
    };
    return Portal;
}(react_1.default.Component));
exports.default = Portal;
//# sourceMappingURL=index.js.map